export default function Marquee({ text = "MOTO PETSAS GP // THRUST MOTORS //" }) {
  const items = Array(6).fill(text);
  return (
    <div
      data-testid="brand-marquee"
      className="overflow-hidden py-10 border-y border-white/5 bg-[#0A0A0A]"
    >
      <div className="flex gap-12 whitespace-nowrap animate-[marquee_60s_linear_infinite]">
        {items.concat(items).map((t, i) => (
          <span
            key={i}
            className="marquee-text font-display font-black uppercase tracking-tight text-7xl md:text-8xl lg:text-9xl"
          >
            {t}
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
